/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_No_SalesInputs */

const en_cargos_sales_range_no_sales = /** @type {(inputs: Cargos_Sales_Range_No_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No bags were sold in this period.`)
};

const es_cargos_sales_range_no_sales = /** @type {(inputs: Cargos_Sales_Range_No_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se vendieron sacos en este período.`)
};

/**
* | output |
* | --- |
* | "No bags were sold in this period." |
*
* @param {Cargos_Sales_Range_No_SalesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_no_sales = /** @type {((inputs?: Cargos_Sales_Range_No_SalesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_No_SalesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_no_sales(inputs)
	return es_cargos_sales_range_no_sales(inputs)
});